/** ⚡ 드롭다운 컨테이너 — 카드 컨텍스트에서 항목 모델을 만들고 열림 상태·진입 계측을 배선한다. */
import { useState } from 'react';
import { useQuizControl } from '../../../components/EditableQuizCard/QuizControlProvider';
import { useQuestionCardAiMenuItems } from '../hooks/useQuestionCardAiMenuItems';
import { QuestionCardAiMenuUI } from './QuestionCardAiMenuUI';
export const QuestionCardAiMenu = () => {
  const {
    id,
    index
  } = useQuizControl();
  const {
    items,
    isLocked,
    trackMenuOpen
  } = useQuestionCardAiMenuItems({
    quizId: id,
    quizIndex: index,
    place: 'card_toolbar'
  });
  const [isOpen, setIsOpen] = useState(false);

  // 지원하지 않는 유형은 항목이 비어 온다 — 트리거도 구분선도 그리지 않는다.
  if (items.length === 0) return null;
  return <QuestionCardAiMenuUI items={items} isLocked={isLocked} open={isOpen} onOpenChange={open => {
    setIsOpen(open);
    if (open) trackMenuOpen();
  }} data-sentry-element="QuestionCardAiMenuUI" data-sentry-component="QuestionCardAiMenu" data-sentry-source-file="QuestionCardAiMenu.tsx" />;
};